export default __webpack_public_path__ + "static/media/Moneybarn_Questionnare.10a39727.pdf";